import styled, { css } from 'styled-components';

const InputStyled = styled.div`
  ${({ hasError }: { hasError: boolean }) => {
    return css`
      label {
        font-weight: bold;
        font-size: 0.875em;
        line-height: 1.5em;
        color: var(--color-charcoal);
        margin: 0 0 0.25em 0;
        display: block;
      }
      input {
        box-sizing: border-box;
        background: var(--color-white);
        border: 0.125em solid var(--tertiary-border-color);
        border-radius: 0.188em;
        font-size: 0.875em;
        line-height: 1.5em;
        color: var(--color-charcoal);
        padding: 0.5em;
        width: 100%;
        display: block;
      }
      input::-webkit-input-placeholder {
        color: var(--color-neutral-60);
      }
      input::-moz-placeholder {
        color: var(--color-neutral-60);
      }
      input:-ms-input-placeholder {
        color: var(--color-neutral-60);
      }
      input:-moz-placeholder {
        color: var(--color-neutral-60);
      }
      ${hasError &&
      css`
        input {
          border: 0.125em solid #d42d2d;
          background: #f9d7d7;
        }
      `}
    `;
  }};
`;

export default InputStyled;
